import { useState } from 'react'
import { Box } from './_shared/Box'
import { SecondaryButton } from './_shared/Buttons/SecondaryButton'
import { CarInsuranceDetails } from './CarInsuranceDetails'
import { ChevronDown } from './icons'

export function CarInsurance({
  car,
  id,
  setShowReportDamage,
  showReportDamage,
}: {
  car: any
  id: string
  setShowReportDamage: any
  showReportDamage: boolean
}) {
  const [open, setOpen] = useState(false)
  return (
    <Box
      title="Bilforsikring"
      actionComponent={<SecondaryButton onClick={() => setShowReportDamage(true)}>Meld skade</SecondaryButton>}
    >
      <button
        onClick={() => setOpen(!open)}
        className={`flex w-full items-center justify-between text-old-primary ease-in-out transition-all 
          `}
      >
        <p className="font-bold text-black">Forsikringsinformasjon</p>
        <span className={`transform transition-all ease-in-out  ${open ? 'rotate-180' : 'rotate-0'}`}>
          <ChevronDown />
        </span>
      </button>
      {open && <CarInsuranceDetails id={id} />}
    </Box>
  )
}
